import React, {useEffect, useRef, useState} from "react";
import {Button, Form, Stack} from "react-bootstrap";
import {useFormikContext} from "formik";

export function Slider({value, name, label, min = 0, max = 100, step = 1, iconLeft, iconRight, onChange, onDone, disabled, interval, timeout}) {
    const [intValue, setIntValue] = useState(value)

    const refTimeout = useRef(null);
    const refInterval = useRef(null);

    const _min = Number(min)
    const _max = Number(max)
    const _step = Number(step)

    useEffect(() => {
        if (typeof onChange === "function") {
            onChange({target: {name: name, value: intValue}})
        }
    }, [intValue])

    useEffect(() => {
        setIntValue(value)
    }, [value]);

    const handleOnDone = () => {
        clearTimeout(refInterval.current)
        clearInterval(refTimeout.current)
        if (typeof onDone === 'function') {
            onDone(intValue)
        }
    }

    const onDecrease = () => {
        const decrease = () => setIntValue(value => value > _min ? value - _step : value)

        decrease()
        refTimeout.current = setTimeout(() => refInterval.current = setInterval(decrease, interval), timeout)
    }
    const onIncrease = () => {
        const increase = () => setIntValue(value => value < _max ? value + _step : value)

        increase()
        refTimeout.current = setTimeout(() => refInterval.current = setInterval(increase, interval), timeout)
    }

    return <Form.Group className="my-1">
        <Form.Label column="">{label}</Form.Label>
        <Stack direction="horizontal" gap="2">
            <Button variant="outline-secondary" disabled={disabled} onMouseDown={onDecrease} onTouchStart={onDecrease} onMouseUp={handleOnDone} onTouchEnd={handleOnDone}>
                <i className={`bi ${iconLeft}`} style={{fontSize: "1.2em"}}/>
            </Button>
            <Form.Range
                min={_min}
                max={_max}
                step={_step}
                disabled={disabled}
                value={intValue}
                onChange={e => setIntValue(Number(e.target.value))}
                onMouseUp={handleOnDone} onKeyUp={handleOnDone} onTouchEnd={handleOnDone}
            />
            <Button variant="outline-secondary" disabled={disabled} onMouseDown={onIncrease} onTouchStart={onIncrease} onMouseUp={handleOnDone} onTouchEnd={handleOnDone}>
                <i className={`bi ${iconRight}`} style={{fontSize: "1.2em"}}/>
            </Button>
        </Stack>
    </Form.Group>
}

function FormikSlider({name, ...props}) {
    const {values, setFieldValue} = useFormikContext()
    const value = values[name]

    return <Slider defaultValue={value} onChange={v => setFieldValue(name, v)} {...props} />
}
